import {TenderPhaseType} from '@frontend/shared-api';
import {environment} from '../../../../../environments/environment';

export const isAiTemplateAnsweringAvailableFor = (phase: TenderPhaseType): boolean =>
  environment.aiTemplateAnsweringEnabled && phase === TenderPhaseType.RFP;
